module.exports = __webpack_public_path__ + "img/Condominio_das_Americas_Guarita.e9003137.jpg";